import React from 'react';
import { motion } from 'framer-motion';
import { ImagesIcon } from 'lucide-react';
const DROPBOX_URL = 'https://www.dropbox.com/scl/fo/7qq37jjntlxacvrib0dhj/AGRTMt28infZFbheEPq_QPc?rlkey=oibjrqalvksef23xivae4ea9n&st=ojbce10h&dl=0';
export function ClosingMessage() {
  return <section className="py-24 px-6 bg-paper-alt border-b border-ink/5" data-id="element-6">
      <div className="max-w-3xl mx-auto" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-8">
          <div className="text-center mb-10" data-id="element-9">
            <span className="block text-amber font-medium tracking-widest uppercase text-sm mb-4" data-id="element-10">
              A Note of Thanks
            </span>
            <h2 className="text-4xl md:text-5xl text-terracotta" data-id="element-11">
              Until We Meet Again
            </h2>
            <div className="flex items-center justify-center gap-4 mt-8 opacity-60" data-id="element-12">
              <div className="w-16 h-[1px] bg-ink" data-id="element-13" />
              <div className="w-2 h-2 rotate-45 bg-amber" data-id="element-14" />
              <div className="w-16 h-[1px] bg-ink" data-id="element-15" />
            </div>
          </div>

          <div className="space-y-5 text-lg text-ink-light leading-relaxed" data-id="element-16">
            <p data-id="element-17">Hi All,</p>
            <p data-id="element-18">
              For those who were able to come to the event — thank you for
              making the time to come to the 5th reunion in San Francisco! It
              was a wonderful event hosted by my sons and daughters-in-law and
              children. I will be ever indebted to them for putting together
              such a great event. Thanks to them, this reunion brought together
              80 members of our family and provided a great experience for us to
              get to know each other better.
            </p>
            <p data-id="element-19">
              I hope that all who attended had an enjoyable time and met and got
              to know more Kan/Au/+ members of our ever-growing relatives from
              many places. For those who were unable to attend, I hope that you
              will have time and consider coming to one of the future events,
              which should occur in 2028 (to be organized by Sister Cynthia Kan
              Rekdal's daughter — Paisley Rekdal), 2030, 2032, and hopefully
              beyond (need volunteers)!!
            </p>
            <p data-id="element-20">
              Again, I am grateful for all of the attendees for making this one
              of the best reunion events we have put together (Seattle, Denver,
              Virginia, and Vancouver BC, Canada were also great).
            </p>
            <p data-id="element-21">
              Videos are available for these events. SF will be put together
              when I can collect the pictures that people will send me to be
              included!! A Dropbox folder has been created by Tim Kan, soon to
              be available to use!
            </p>
          </div>

          <div className="mt-12 text-center" data-id="element-22">
            <p className="text-xl text-sage italic" data-id="element-23">
              Again, thank all who attended,
            </p>
            <p className="mt-2 text-2xl text-terracotta" data-id="element-24">Kingsley</p>
          </div>

          {/* Photo sharing */}
          <div className="mt-16 bg-paper rounded-sm border border-ink/5 p-8 md:p-10 text-center" data-id="element-25">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-terracotta/10 text-terracotta mb-5" data-id="element-26">
              <ImagesIcon className="w-7 h-7" data-id="element-27" />
            </div>
            <h3 className="text-2xl md:text-3xl text-ink mb-3" data-id="element-28">
              Share & View Photos
            </h3>
            <p className="text-ink-light leading-relaxed max-w-xl mx-auto mb-8" data-id="element-29">
              We'd love to relive the weekend together. Add your photos from the
              reunion — and browse everyone else's — in our shared Dropbox
              folder.
            </p>
            <a href={DROPBOX_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-terracotta text-white px-10 py-4 rounded-sm text-lg transition-all hover:bg-[#A85D45] hover:-translate-y-1 hover:shadow-xl hover:shadow-terracotta/20 duration-300" data-id="element-30">
              <ImagesIcon className="w-5 h-5" data-id="element-31" />
              Open the Photo Dropbox
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}